import CopyOutlined from '@ant-design/icons/CopyOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import Dropdown from 'antd/es/dropdown';
import type { MenuProps } from 'antd/es/menu';
import React from 'react';

export interface ContextMenuProps {
  children: React.ReactNode;
  items: ContextMenuItem[];
  onAction: (action: string, data?: unknown) => void;
  disabled?: boolean;
}

export interface ContextMenuItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  danger?: boolean;
  divider?: boolean;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
  children,
  items,
  onAction,
  disabled = false,
}) => {
  const menuItems: MenuProps['items'] = items.map((item) => {
    if (item.divider) {
      return { type: 'divider', key: `divider-${item.key}` };
    }

    return {
      key: item.key,
      label: item.label,
      icon: item.icon,
      disabled: item.disabled,
      danger: item.danger,
      onClick: () => onAction(item.key),
    };
  });

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['contextMenu']}
      placement="bottomLeft"
    >
      {children}
    </Dropdown>
  );
};

// Predefined context menu items for common actions
export const createNodeContextMenuItems = (
  _nodeId: string,
  isSelected: boolean,
): ContextMenuItem[] => [
  {
    key: 'configure',
    label: 'Configure',
    icon: <SettingOutlined />,
  },
  {
    key: 'divider-1',
    label: '',
    divider: true,
  },
  {
    key: 'delete',
    label: isSelected ? 'Delete Selected Node' : 'Delete Node',
    icon: <DeleteOutlined />,
    danger: true,
  },
];

export const createCanvasContextMenuItems = (): ContextMenuItem[] => [
  {
    key: 'add-block',
    label: 'Add Block',
    icon: <CopyOutlined />,
  },
];

export const createEdgeContextMenuItems = (
  _edgeId: string,
  _sourceBlockType?: string,
  _targetBlockType?: string,
): ContextMenuItem[] => [
  {
    key: 'delete',
    label: 'Delete Connection',
    icon: <DeleteOutlined />,
    danger: true,
  },
];
